import { getEditLocation } from "../../../core/util/functions";

export const mainBoardLocation = "/domestic/mainpanel"
